import React from "react";
import CommentList from "../../Components/Comment/CommentList";
// import LeftMenu from "../../Components/LeftMenu";
import queryString from "query-string";

const CommentListPage = ({ match, location }) => {
  const query = queryString.parse(location.search);
  return (
    <React.Fragment>
      {/* <LeftMenu /> */}
      <CommentList
        pageNumber={query.pageNumber}
        search={query.search}
        type={query.type}
      />
    </React.Fragment>
  );
};

export default CommentListPage;
